/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TitleSchedulePPD = {
    type: 'all-of',
    contains: [{
    type: 'PPDDetail',
}, {
    properties: {
        title_id: {
    type: 'number',
    isRequired: true,
},
        title_name: {
    type: 'string',
    isRequired: true,
},
    },
}],
};